import script from "./ResetPasswordDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordDrawer.vue?vue&type=style&index=0&id=c556045e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c556045e"]])

export default __exports__